/**
 * Intercept fetch method. Add all fetch decorating methods
 */
import config from "../environment/environment-config";

const LOGIN_PATH = config.loginUrl;
const _fetch = window.fetch;
window.fetch = function (...args) {
  return new Promise((resolve, reject) => {
    try {
      _fetch
        .apply(this, addXRequestedWithHeader(addCSRFHeader(args as any)))
        .then((response: Response) => {
          if (response.status === 401) {
            window.location.href = LOGIN_PATH;
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (_ignore) {}
  });
};

function addXRequestedWithHeader(args: IArguments) {
  Object.keys(args).forEach((element) => {
    if (args[element] && args[element].headers) {
      args[element].headers["X-Requested-With"] = "XMLHttpRequest";
      return args;
    }
  });

  return args;
}

/**
 * Add CSRF token to arguments. Assumes that CSRF token is in window object under '_csrf'
 */
function addCSRFHeader(args: IArguments): IArguments {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const csrfToken = (window as any).token?._csrf;
  if (csrfToken) {
    Object.keys(args).forEach((element) => {
      if (args[element] && args[element].headers) {
        const keycloakApiUrl = (window as any).keycloakApi;
        if (!keycloakApiUrl || (args[0] && !args[0].includes(keycloakApiUrl))) {
          args[element].headers.CSRFToken = csrfToken;
        }
        return args;
      }
    });
  }
  return args;
}
